const PRIVATE_PATH = {
	ACCOUNT: '/private/account',
	CONTACT_INFORMATION: '/private/account/contact-information',
	NOTIFICATIONS: '/private/account/notifications',
	PAST_SHIFTS: '/private/past-shifts',
	PROFESSIONALS_ON_DEMAND: '/private/professionals/on-demand',
	PROFESSIONALS_INTERNAL_STAFF: '/private/professionals/internal-staff',
	SHIFTS: '/private/shifts',
	SETTINGS: '/private/settings',
	REPORTS: '/private/reports',
	GLOBAL_OVERVIEW: '/private/global-overview',
	PROFESSIONALS_PAGE: '/private/agency/professionals',
	WORKFORCE_PAGE: '/private/workforce',
	COMPANY_SETTINGS: '/private/company-settings'
};

export default PRIVATE_PATH;
